<style lang="scss" scoped>
.switch {
  height: 100%;
  padding: 0;
  margin: 0;
  align-items: center;
  display: flex;

  i {
    margin-right: 5px;
  }

  &.activeHover {
    button {
      height: 30px;
      text-transform: capitalize;

      &.v-btn:before {
        opacity: 0 !important;
      }

      &.v-btn--active:before,
      &.v-btn:hover:before,
      &.v-btn:focus:before {
        background: none;
      }

      .v-ripple__container {
        opacity: 0 !important;
      }

      .v-btn__content:hover {
        span {
          color: #0f6dfa !important;
        }

        i {
          color: #0f6dfa !important;
        }
      }
    }
  }
}
</style>

<template>
  <div
    class="switch"
    :class="{ activeHover: isActiveHover }"
    v-if="localizationEnabled"
  >
    <template v-for="entry in languages">
      <v-btn
        flat
        :color="color"
        @click="changeLocale(entry.language)"
        :key="entry.title"
        v-if="$i18n.locale != entry.language"
      >
        <v-icon :color="color" left>language</v-icon>
        <span>{{ entry.title }}</span>
      </v-btn>
    </template>
  </div>
</template>

<script>
import { LANGUAGES } from "/src/maps/i18n";
import { LocaleMixin } from "/src/mixins/locale-mixin";

export default {
  name: "LocalizationSwitch",
  props: {
    color: {
      type: String,
      default: "#55686e",
    },
    isActiveHover: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [LocaleMixin],
  data() {
    return {
      languages: LANGUAGES,
    };
  },
};
</script>
